import { render } from "./MasClientesNew.vue?vue&type=template&id=a44eddee&scoped=true"
import script from "./MasClientesNew.vue?vue&type=script&lang=js"
export * from "./MasClientesNew.vue?vue&type=script&lang=js"

import "./MasClientesNew.vue?vue&type=style&index=0&id=a44eddee&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44eddee"]])

export default __exports__